import { Components, Theme } from '@mui/material';
import scssVariables from '@styles/variables.module.scss';

export const MuiFormHelperText: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: {
      font: scssVariables.FontLabel,
      marginLeft: 0,
      '&.Mui-error': {
        color: scssVariables.ColorCoral80,
      },
    },
  },
};
